import { defineStore } from 'pinia'

export const useMainStore = defineStore('main', {
  state: () => ({
    dataAttributes: {},
  }),
  getters: {
    // API URLs
    apiUrl: (state) => state.dataAttributes.apiUrl || '',
    apiVigotr: (state) => state.dataAttributes.apiVigotr || '',
    apiDok: (state) => state.dataAttributes.apiDok || '',
    
    // API Key
    apiKey: (state) => state.dataAttributes.apiKey || '',
    
    // Externe Links
    impressumUrl: (state) => state.dataAttributes.impressumUrl || '',
    datenschutzUrl: (state) => state.dataAttributes.datenschutzUrl || '',
    
    // Rechner-Konfiguration
    rechner: (state) => state.dataAttributes.rechner || 'arn',
    funktion: (state) => state.dataAttributes.funktion || '1',
    code1: (state) => state.dataAttributes.code1 || '',
    code2: (state) => state.dataAttributes.code2 || '',
    kanal: (state) => state.dataAttributes.kanal || 'meinevigo',
    version: (state) => state.dataAttributes.version || '2',
    
    // Feature Flags
    test: (state) => state.dataAttributes.test === 'true',
    aokEnabled: (state) => state.dataAttributes.aokEnabled === 'true',
    
    // Matomo Tracking
    // MATOMO-DEAKTIVIERT (TODO: reaktivieren)
    //matomoHost: (state) => state.dataAttributes.matomoHost || '',
    //matomoSiteid: (state) => state.dataAttributes.matomoSiteid || '',
    //matomoTrackerFileName: (state) => state.dataAttributes.matomoTrackerFileName || 'matomo',
    //matomoEnableLinkTracking: (state) => state.dataAttributes.matomoEnableLinkTracking === 'true',
    //matomoTrackInitialView: (state) => state.dataAttributes.matomoTrackInitialView === 'true',
    
    // Theme-Unterscheidung (v4y = meinevigo Kombi-Rechner)
    isV4yTheme(state) {
      const rechner = state.dataAttributes.rechner
      const kanal = state.dataAttributes.kanal
      
      const isKombi = rechner === 'kombi' || rechner === 'kombistat'
      const isMeinevigo = kanal === 'meinevigo'
      
      return isKombi && isMeinevigo
    },
    
    // Abgeleitete Theme-Werte
    classPrefix() {
      return this.isV4yTheme ? 'v4y-' : ''
    },
    themeCheckColor() {
      return this.isV4yTheme ? '#FA9F42' : '#577c32'
    },
    
    // Ermittelt die aktuelle Tarifvariante basierend auf rechner und kanal
    currentVariante(state) {
      const rechner = state.dataAttributes.rechner
      const kanal = state.dataAttributes.kanal
      
      // Kombi-Rechner: Unterscheidung nach Kanal
      if (rechner === 'kombi' || rechner === 'kombistat') {
        return kanal === 'meinevigo' ? '4YOU' : 'Kombi'
      }
      
      // ARN: Immer Nachhaltig
      if (rechner === 'arn') {
        return 'Nachhaltig'
      }
      
      // AR20: Immer AR20
      if (rechner === 'ar20') {
        return 'AR20'
      }
      
      // Fallback für unbekannte Rechner
      return null
    },
    
    // Produktname für Textausgaben (select / 4YOU / leer)
    // Gibt HTML zurück: "<em>vigo</em> select" oder "<em>vigo</em>4YOU"
    produktName(state) {
      const kanal = state.dataAttributes.kanal
      
      if (kanal === 'vigoselect') {
        return '<em>vigo</em> select'; // MIT Leerzeichen
      } else if (kanal === 'meinevigo' || kanal === 'vigokv') {
        return '<em>vigo</em> 4YOU'; // OHNE Leerzeichen
      }
      return '';
    },
  },
  actions: {
    setDataAttributes(element) {
      const attributes = {}
      // Alle data-* Attribute des Elements sammeln
      for (let attr of element.attributes) {
        if (attr.name.startsWith('data-')) {
          // data-api-url wird zu apiUrl, data-theme wird zu theme, etc.
          const key = attr.name.slice(5).replace(/-([a-z])/g, (g) => g[1].toUpperCase())
          attributes[key] = attr.value
        }
      }
      this.dataAttributes = attributes
    },
    updateDataAttribute(key, value) {
      this.dataAttributes[key] = value
    }
  },
  persist: {
    storage: sessionStorage
  }
})
